// Albums
export const ALBUM_INDEX_REQUEST: string = "Music/Albums/INDEX_REQUEST";
export const ALBUM_INDEX_SUCCESS: string = "Music/Albums/INDEX_SUCCESS";
export const ALBUM_INDEX_FAILURE: string = "Music/Albums/INDEX_FAILURE";

export const ALBUM_STORE_REQUEST: string = "Music/Albums/STORE_REQUEST";
export const ALBUM_STORE_SUCCESS: string = "Music/Albums/STORE_SUCCESS";
export const ALBUM_STORE_FAILURE: string = "Music/Albums/STORE_FAILURE";

export const ALBUM_SHOW_REQUEST: string = "Music/Albums/SHOW_REQUEST";
export const ALBUM_SHOW_SUCCESS: string = "Music/Albums/SHOW_SUCCESS";
export const ALBUM_SHOW_FAILURE: string = "Music/Albums/SHOW_FAILURE";

export const ALBUM_UPDATE_REQUEST: string = "Music/Albums/UPDATE_REQUEST";
export const ALBUM_UPDATE_SUCCESS: string = "Music/Albums/UPDATE_SUCCESS";
export const ALBUM_UPDATE_FAILURE: string = "Music/Albums/UPDATE_FAILURE";

export const ALBUM_DESTROY_REQUEST: string = "Music/Albums/DESTROY_REQUEST";
export const ALBUM_DESTROY_SUCCESS: string = "Music/Albums/DESTROY_SUCCESS";
export const ALBUM_DESTROY_FAILURE: string = "Music/Albums/DESTROY_FAILURE";

export const ALBUM_SEARCH_REQUEST: string = "Music/Albums/SEARCH_REQUEST";
export const ALBUM_SEARCH_SUCCESS: string = "Music/Albums/SEARCH_SUCCESS";
export const ALBUM_SEARCH_FAILURE: string = "Music/Albums/SEARCH_FAILURE";

// Tracks
export const TRACK_INDEX_REQUEST: string = "Music/Tracks/INDEX_REQUEST";
export const TRACK_INDEX_SUCCESS: string = "Music/Tracks/INDEX_SUCCESS";
export const TRACK_INDEX_FAILURE: string = "Music/Tracks/INDEX_FAILURE";

export const TRACK_STORE_REQUEST: string = "Music/Tracks/STORE_REQUEST";
export const TRACK_STORE_SUCCESS: string = "Music/Tracks/STORE_SUCCESS";
export const TRACK_STORE_FAILURE: string = "Music/Tracks/STORE_FAILURE";

export const TRACK_SHOW_REQUEST: string = "Music/Tracks/SHOW_REQUEST";
export const TRACK_SHOW_SUCCESS: string = "Music/Tracks/SHOW_SUCCESS";
export const TRACK_SHOW_FAILURE: string = "Music/Tracks/SHOW_FAILURE";
export const TRACK_SHOW_REDIRECT: string = "Music/Tracks/SHOW_REDIRECT";

export const TRACK_UPDATE_REQUEST: string = "Music/Tracks/UPDATE_REQUEST";
export const TRACK_UPDATE_SUCCESS: string = "Music/Tracks/UPDATE_SUCCESS";
export const TRACK_UPDATE_FAILURE: string = "Music/Tracks/UPDATE_FAILURE";

export const TRACK_DESTROY_REQUEST: string = "Music/Tracks/DESTROY_REQUEST";
export const TRACK_DESTROY_SUCCESS: string = "Music/Tracks/DESTROY_SUCCESS";
export const TRACK_DESTROY_FAILURE: string = "Music/Tracks/DESTROY_FAILURE";

export const TRACK_SEARCH_REQUEST: string = "Music/Tracks/SEARCH_REQUEST";
export const TRACK_SEARCH_SUCCESS: string = "Music/Tracks/SEARCH_SUCCESS";
export const TRACK_SEARCH_FAILURE: string = "Music/Tracks/SEARCH_FAILURE";

// Artists
export const ARTIST_SHOW_REQUEST: string = "Music/Artists/SHOW_REQUEST";
export const ARTIST_SHOW_SUCCESS: string = "Music/Artists/SHOW_SUCCESS";
export const ARTIST_SHOW_FAILURE: string = "Music/Artists/SHOW_FAILURE";
